import { useContext } from "react";
import { RelativePerformanceLayout } from "./layout/RelativePerformanceLayout";
import { ChartSection } from "../../layout/ChartSection";
import { RefProvider } from "./store/RefContext";
import { LayoutProvider } from "./store/LayoutContext";
import { LocalStoreProvider } from "./store/LocalStore";
import { StoreContext } from "../../store/Store";

export const RelativePerformance = () => {
  const [store] = useContext(StoreContext);
  const { dimensions } = store;
  return (
    <ChartSection header="" height={dimensions.vh}>
      <LayoutProvider>
        <RefProvider>
          <LocalStoreProvider>
            <RelativePerformanceLayout />
          </LocalStoreProvider>
        </RefProvider>
      </LayoutProvider>
    </ChartSection>
  );
};
